// extracted by mini-css-extract-plugin
export default {"wrap":"DeactivateProfile__wrap___2A1Pb","buttonField":"DeactivateProfile__buttonField___2DxKY"};